import { generatePath } from 'react-router';

import { getModulesByMode, MODULES } from 'constants/ModuleConstants';
import { PATH } from 'constants/RoutesConstants';

import type { ModeEnum } from 'modules/global/typing/enums/modes.enum';
import type { ModuleEnum } from 'modules/global/typing/enums/module.enum';

interface GetLinkParams {
  entityId: string;
  module?: ModuleEnum;
  mode?: ModeEnum;
  isAppointment?: boolean;
  isCampaign?: boolean;
  search?: string;
}

export const getLink = ({ entityId, module: moduleProps, mode, isAppointment, isCampaign, search }: GetLinkParams) => {
  const module = moduleProps ?? (mode ? getModulesByMode(mode).shift() : undefined);
  let path = generatePath((module ? MODULES[module]?.path : undefined) ?? '/', { interventionId: entityId });

  if (isCampaign) {
    path = generatePath(PATH.CAMPAIGNS_DETAILS.path, { campaignId: entityId });
  }

  if (isAppointment) {
    path = generatePath(PATH.KEY_DROP_OFF_APPOINTMENTS_DETAILED.path, { appointmentId: entityId });
  }

  if (search) {
    const searchParams = new URLSearchParams(search);
    path = `${path}?${searchParams.toString()}`;
  }

  return path;
};
